<template>
  <div>
    <form @submit.prevent="saveVariant">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <span class="pl-2">
            {{ input ? "Edit" : "Add" }} Variant Item
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2 mb-2">
              <b-col md="3">
                <label class="variant-label">
                  Category Name
                </label>
              </b-col>
              <b-col md="5">
                <SearchSelect
                  :item-id="'category_id'"
                  :name="'category_name'"
                  :obj="obj"
                  :v-model="obj.category_id"
                  :options="selectOptions"
                  :value="'id'"
                  :text="'name'"
                  :change-search-value="changeSearchValue"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-2" />
            <b-row class="mt-2 mb-2">
              <b-col md="3">
                <b-button variant="success" @click="addVariantItem">
                  Add Variant Item
                </b-button>
              </b-col>
            </b-row>
            <div v-for="(item, index) in obj.variant_items" :key="index">
              <b-row class="mt-2 mb-2">
                <b-col md="3">
                  <label class="variant-label">
                    Variant Name
                  </label>
                </b-col>
                <b-col md="5">
                  <b-form-input v-model="item.name" type="text" name="name" />
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="3">
                  <label class="variant-label">
                    Variant Value
                  </label>
                </b-col>
                <b-col md="5">
                  <b-form-input v-model="item.value" min="0" type="number" name="value" />
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="3">
                  <label class="variant-label">
                    Is Active
                  </label>
                </b-col>
                <b-col md="5">
                  <b-form-radio-group
                    v-model="item.isActive"
                    :options="activeOptions"
                    class="item-produced"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-2 mb-2">
                <b-col md="8">
                  <b-button variant="danger" @click="minusVariantItem(index)">
                    Delete Variant Item
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <b-row class="mt-2 mb-2">
              <b-col md="3">
                <label class="variant-label">
                  Visibility
                </label>
              </b-col>
              <b-col md="5" class="mt-1">
                <b-form-radio-group
                  v-model="obj.is_visable"
                  :options="activeOptions"
                  name="is_visable"
                  class="item-produced"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-2">
              <b-col md="3">
                <label class="variant-label">
                  Pick Option
                </label>
              </b-col>
              <b-col md="5" class="mt-1">
                <b-form-radio-group
                  v-model="obj.option"
                  :options="optionalQuantityOptions"
                  name="option"
                  class="item-produced"
                />
              </b-col>
            </b-row>
            <b-row v-if="obj.option === 2" class="mt-2 mb-2">
              <b-col md="3">
                <label class="variant-label">
                  Maximun
                </label>
              </b-col>
              <b-col md="5" class="mt-1">
                <b-form-input v-model="obj.max" min="0" type="number" name="max" />
              </b-col>
            </b-row>
            <b-row v-if="obj.option === 2" class="mt-2 mb-2">
              <b-col md="3">
                <label class="variant-label">
                  Minimun
                </label>
              </b-col>
              <b-col md="5" class="mt-1">
                <b-form-input v-model="obj.min" min="0" type="number" name="min" />
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import SearchSelect from '@/components/SearchSelect/index.vue';
import constants from '@/utils/constants';
export default {
  components: {
    SearchSelect
  },
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const { menuitemcode, outletcode } = this.$route.params;
    return {
      obj: {
        variant_items: [],
        category_id: '',
        category_name: '',
        is_visable: true,
        option: 1,
        max: '',
        min: '',
        outlet_code: outletcode,
        menu_item_code: menuitemcode
      },
      activeOptions: [
        { text: 'true', value: true },
        { text: 'false', value: false }
      ],
      optionalQuantityOptions: [
        { text: 'Single', value: 1 },
        { text: 'Multiple', value: 2 }
      ],
      selectOptions: []
    };
  },

  computed: {},

  mounted() {
    this.$store.dispatch('GetAllCategoryItem').then(res => {
      this.selectOptions = res;
    });
  },

  methods: {
    changeSearchValue(value) {
      this.$store.commit('SET_FILTERING_CATEGORY', value);
      this.$store.dispatch('GetAllCategoryItem').then(res => {
        this.selectOptions = res;
      });
    },
    saveVariant() {
      const payload = _.cloneDeep(this.obj);
      payload.min = Number(payload.min);
      payload.max = Number(payload.max);
      if (payload.variant_items[0]) {
        payload.variant_items.map(item => {
          return (item.value = Number(item.value));
        });
      }
      if (!payload.category_id) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'Category should not be empty',
          constants.STATUS_ERROR
        );
      }
      if (!payload.variant_items || !payload.variant_items.length) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'Variants should not be empty',
          constants.STATUS_ERROR
        );
      }
      for (let i = 0; i < payload.variant_items.length; i++) {
        const element = payload.variant_items[i];
        if (!element.name || !String(element.value)) {
          return this.$swal(
            constants.SOMETHING_WROING,
            'Variants items should have name and value',
            constants.STATUS_ERROR
          );
        }
      }
      if (payload.id) {
        return this.$store.dispatch('UpdateVariantItem', payload).then(res => {
          if (res.data.message === constants.STATUS_OK_UPPER) {
            this.$swal(
              constants.SUCCESS_MESSAGE,
              'Variant Updated',
              constants.STATUS_SUCCESS
            );
            this.discardModal();
          } else {
            this.$swal(
              constants.SOMETHING_WROING,
              res.invalidMessage,
              constants.STATUS_ERROR
            );
          }
        });
      }
      this.$store.dispatch('CreateVariantItem', payload).then(res => {
        if (res.data.message === constants.STATUS_OK_UPPER) {
          this.$swal(
            constants.SUCCESS_MESSAGE,
            'Variant Created',
            constants.STATUS_SUCCESS
          );
          this.discardModal();
        } else {
          this.$swal(
            constants.SOMETHING_WROING,
            res.invalidMessage,
            constants.STATUS_ERROR
          );
        }
      });
    },
    discardModal() {
      this.reset();
      this.$store.dispatch('UpdateFilteringCategoryItem', {
        isResetFilter: true
      });
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      const { menuitemcode, outletcode } = this.$route.params;
      if (!this.input) {
        this.obj = {
          variant_items: [],
          category_id: '',
          category_name: '',
          is_visable: true,
          option: 1,
          max: '',
          min: '',
          outlet_code: outletcode,
          menu_item_code: menuitemcode
        };
      } else {
        const newinput = _.cloneDeep(this.input);
        this.obj = newinput;
      }
    },
    addVariantItem() {
      const cloneVariantsList = _.cloneDeep(this.obj.variant_items);
      cloneVariantsList.push({
        name: '',
        value: '',
        isActive: true
      });
      this.obj.variant_items = cloneVariantsList;
    },
    minusVariantItem(index) {
      const cloneVariantsList = _.cloneDeep(this.obj.variant_items);
      cloneVariantsList.splice(index, 1);
      this.obj.variant_items = cloneVariantsList;
    }
  }
};
</script>
